import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../icon'

export const Checkbox = ({
  title,
  isI18n,
  translateProps,
  value,
  checked,
  style,
  styleIcon,
  className,
  onChange,
  isCheckOnClickText,
  allowChange,
  appendStyle,
}) => {
  const [isCheck, setIsCheck] = useState(checked)

  useEffect(() => {
    setIsCheck(checked)
  }, [checked])

  const onToggle = (e) => {
    e?.stopPropagation()
    if (allowChange) {
      onChange ? onChange(!isCheck) : setIsCheck(!isCheck)
    }
  }

  const onClickText = (e) => {
    if (isCheckOnClickText) {
      e?.stopPropagation()
      onToggle(e)
    }
  }

  const getColor = () => {
    if (allowChange) {
      return isCheck && isCheck !== -1 ? '#2C73E8' : '#9C9C9C'
    }

    return '#D5D5D5'
  }

  const getIconClass = () => {
    if (isCheck === -1) {
      return 'icon-checkbox-minus'
    }

    return isCheck ? 'icon-checkbox-check' : 'icon-checkbox-uncheck'
  }

  return (
    <div
      id={String(value)}
      className="dFlex alignItemsCenter"
      style={appendStyle}
    >
      <div className="dFlex alignItemsCenter" onClick={onToggle}>
        <Icon
          className={getIconClass()}
          style={{
            color: getColor(),
            ...styleIcon,
          }}
        />
      </div>
      {title && (
        <span
          style={{ paddingLeft: 10, ...style }}
          className={[
            isCheckOnClickText ? 'cursorPointer' : '',
            className,
          ].join(' ')}
          onClick={onClickText}
        >
          {isI18n ? <Translate value={title} {...translateProps} /> : title}
        </span>
      )}
    </div>
  )
}

Checkbox.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]),
  isI18n: PropTypes.bool,
  translateProps: PropTypes.object,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  style: PropTypes.object,
  styleIcon: PropTypes.object,
  className: PropTypes.string,
  isCheckOnClickText: PropTypes.bool,
  onChange: PropTypes.func,
  allowChange: PropTypes.bool,
  appendStyle: PropTypes.object,
}

Checkbox.defaultProps = {
  isI18n: false,
  translateProps: {},
  checked: false,
  style: {},
  styleIcon: {},
  className: '',
  isCheckOnClickText: false,
  allowChange: true,
  appendStyle: {},
}
